module["exports"] = [
  "Dhr.",
  "Mevr. Dr.",
  "Bsc",
  "Msc",
  "Prof."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/name/prefix.js
 ** module id = 899
 ** module chunks = 0
 **/